export default __webpack_public_path__ + "static/UNICORE LAMINATE-55a7f460b5b4fc9c0543ec8c64238b3b.webp";